$(document).ready(function() {
  $("#main-slick").on('init', function(event, slick) {
    $('.fvSlider__image').css('opacity', 1);
  });

  $("#main-slick").slick({
    autoplay: true,
    centerMode: true,
    centerPadding: '10%',
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
        }
      }
    ]
  });

    //   // 特定の日付と時間に基づいてスライドを削除する
    // function removeSlideBasedOnDateTime() {
    //     var now = new Date();
    //     var displayStartDate = new Date("2024-03-01T13:43:00"); 
    //     var displayEndDate = new Date("2024-03-01T13:45:00"); 

    //     if (now < displayStartDate || now > displayEndDate) {
    //         var indexToRemove = $("#main-slick").find('[data-slick-index="0"]').data('slick-index');
    //         if (typeof indexToRemove !== 'undefined') {
    //             $("#main-slick").slick('slickRemove', indexToRemove);
    //         }
    //     }
    // }

    // removeSlideBasedOnDateTime();
});


